import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { Tooltip } from '@meitu/saas-ui';
import { type FormatBrushState } from '@meitu/saas-editor-core/es/framework';
import { type TextLayer } from '@meitu/saas-editor-core/es/layers/text-layer';
import { LayerType } from '@meitu/saas-editor-core/es/version-types';
import IconFont from '@meitu/xdesign-icon-font';
import { useEditor } from '@/hooks/use-editor';
import { useLocaleStore } from '@/i18n';
import { ICallback, IToolLayout } from '../../types';

const TextBrushBtn = ({
    id,
    onCopyBrush,
    onApplyBrush,
}: Pick<IToolLayout & ICallback, 'id' | 'onCopyBrush' | 'onApplyBrush'>) => {
    const { $t } = useLocaleStore();
    const editor = useEditor();
    const formatBrushService = editor.services.formatBrush;

    const [formatBrush, setFormatBrush] = useState<FormatBrushState | null>(formatBrushService.getState());

    useEffect(() => {
        setFormatBrush(formatBrushService.getState());
        const offFormatBrush = formatBrushService.onChange(setFormatBrush);
        return () => {
            offFormatBrush();
        };
    }, [formatBrushService, id]);

    return (
        <Tooltip placement="bottom" title={$t((v) => v.headerToolbar.textBrushBtn.copyStyle)}>
            <div
                onClick={() => {
                    const textLayer = editor.getInstance<TextLayer>('TextLayer');
                    const started = textLayer.setTextBrush(
                        id,
                        $t((v) => v.baseLayer.shortcutOperate.cursorTip),
                        onApplyBrush,
                    );
                    if (!started) return;
                    onCopyBrush?.();
                }}
                className={classNames('c-header-toolbar-actions-btn', {
                    active: formatBrush?.targetLayerType === LayerType.TEXT_LAYER && formatBrush.sourceLayerId === id,
                })}
            >
                <IconFont fontSize={14} name="FormatPainterBold" />
            </div>
        </Tooltip>
    );
};

export default React.memo(TextBrushBtn);
